import { createStyles, makeStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';

import { EeSelect, EeSelectProps } from 'components/EeSelect/EeSelect';

const menuStyles = makeStyles(() =>
  createStyles({
    paper: {
      transitionDuration: '0s !important',
    },
  }),
);

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      fontSize: 40,
      backgroundColor: '#f5f7f9',
      '&:focus, &:active': {
        backgroundColor: '#f5f7f9',
      },
      padding: '0 24px 0 0',
      fontWeight: 300,
    },
    icon: {
      fontSize: 40,
      right: -2,
      top: 8,
      color: '#57759c',
    },
  }),
);

export function HeaderDropDown(props: EeSelectProps) {
  const classes = useStyles();
  const menuClasses = menuStyles();
  return (
    <EeSelect
      classes={classes}
      IconComponent={ExpandMoreIcon}
      MenuProps={{
        classes: menuClasses,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
      }}
      {...props}
    />
  );
}
